import { Component, OnInit } from '@angular/core';
import { Role, RoleRight, Rule, User, RuleGroup, RuleGroupSet } from 'src/app/classes';
import { Guid } from "../../globals";
import { PopUpData, PopUpComponent } from "../pop-up/pop-up.component";
import { BackEndService } from "../../backend-service";
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-manage-roles',
  templateUrl: './manage-roles.component.html',
  styleUrls: ['./manage-roles.component.css']
})
export class ManageRolesComponent implements OnInit {
  /**
   * the method returns the current selected role
   */
  public get currentRole(): Role {
    var role = this.roles.find(x => x.id == this.rolePointer);
    if (typeof (role) == "undefined" || role == null) return null;
    return role;
  }
  /**
   * the method returns a set of users
   */
  get currentUsers(): User[] {
    return this.users.filter(x => x.roleIds.includes(this.rolePointer));
  }
  roleName: string = "";
  roleUserIds: string[] = [];
  /**
   * the components roles
   */
  public roles: Role[] = [];
  /**
   * the components role rights
   */
  public roleRights: RoleRight[] = [];
  /**
   * the current roles id
   */
  public rolePointer: string = null;
  /**
   * the components rules
   */
  public ruleGroups: RuleGroupSet[] = [];

  get rules(): Rule[]{
    let output = [];
    for(let group of this.ruleGroups) {
      for(let rule of group.rules) output.push(rule);
    }
    return output;
  }
  /**
   * the method returns the total rule counter
   */
  public get ruleCount(): number {
    var number = 0;
    for(let group of this.ruleGroups) number += group.rules.length;
    return number;
  }
  /**
   * the object contains all groups and their visibility
   */
  public toggleMap = {};
  /**
   * the object contains the rule value set
   */
  public valueMap = {};
  /**
   * the components users
   */
  public users: User[] = [];
  /**
   * the constructor creates a new instance of the component
   */
  constructor(
    private backEndService: BackEndService,
    private router: Router,
    private _popUp: MatSnackBar
  ) { }
  /**
   * the method adds a new user
   */
  addRole() {
    var newRoles = this.roles.filter(x => x.isNew);
    var r: Role = null;
    if (newRoles.length == 0) {
      r = new Role();
      r.id = Guid.newGuid();
      r.isNew = true;
      this.roles.push(r);
    } else {
      r = newRoles[0];
    }
    this.setRole(r);
  }
  /**
   * the method returns whether the current role can be deleted
   */
  canDeleteRole(): boolean {
    if(this.rolePointer == null) return false;
    if(this.currentRole == null) return false;
    if(this.currentRole.isNew == false) return true;
    return false;
  }
  /**
   * the method deletes the current role
   */
  deleteRole() {
    var r = this.currentRole;
    var confirmed = confirm("Möchten Sie die Rolle " + r.name + " wirklich löschen?");
    if (confirmed) {
      this.backEndService.delete(Role.url + "/" + this.rolePointer).subscribe(
        (success) => {
          this.removeRole();
          this.rolePointer = null;
          console.log(success);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }
  /**
   * the method checks whether the given value is empty or not
   */
  isEmpty(value: string) {
    if (value == null || value == "") return true;
    return false;
  }
  /**
   * the method returns whether the group is toggled within the current view or not
   */
  isVisible(group: RuleGroup): boolean {
    if(group == null) return this.toggleMap["_"];
    else return this.toggleMap[group.rulegroupid.toString()];
  }
  /**
   * the method is called on component initalization
   */
  ngOnInit() {
    this.backEndService.get(Role.url).subscribe(
      (roles: Role[]) => {
        for (let role of roles) {
          role.isNew = false;
        }
        this.roles = roles;
      },
      (error) => {
        console.log(error);
      }
    );
    this.backEndService.get("api/rule").subscribe((data: RuleGroupSet[]) => {
      this.ruleGroups = data;
      for(let group of data){
        if(group.group == null) this.toggleMap["_"] = false;
        else this.toggleMap[group.group.rulegroupid.toString()] = false;
        for(let rule of group.rules) this.valueMap[rule.ruleid.toString()] = false;
      }
    });
    this.backEndService.get(User.url).subscribe(
      (users: User[]) => {
        for (let user of users) {
          user.isNew = false;
        }
        this.users = users;
      },
      (error) => {
        console.log(error);
      }
    );
  }
  /**
   * the method permits all rights for the current role
   */
  permitAllRights(){
    for(let index in this.toggleMap) this.toggleMap[index] = true;
    this.backEndService.get("api/role-right/permit-all/" + this.rolePointer).subscribe((result) => {
      for(let rule of this.rules){
        let roleRight = this.roleRights.find(x => x.roleid == this.rolePointer && x.ruleid == rule.ruleid);
        if(!roleRight){
          roleRight = new RoleRight();
          roleRight.roleid = this.rolePointer;
          roleRight.ruleid = rule.ruleid;
          this.roleRights.push(roleRight);
        }
        roleRight.value = true;
      }
    });
  }
  /**
   * the method permits all necessary rights for the current role
   */
  permitAllNecessaryRights(){
    for(let index in this.toggleMap) this.toggleMap[index] = true;
    this.backEndService.get("api/role-right/permit-all-necessary/" + this.rolePointer).subscribe((result) => {
      for(let rule of this.rules){
        if(!rule.ruleisnecessary) continue;
        let roleRight = this.roleRights.find(x => x.roleid == this.rolePointer && x.ruleid == rule.ruleid);
        if(!roleRight){
          roleRight = new RoleRight();
          roleRight.roleid = this.rolePointer;
          roleRight.ruleid = rule.ruleid;
          this.roleRights.push(roleRight);
        }
        roleRight.value = true;
      }
    });
  }
  /**
   * the method removes a role
   */
  removeRole() {
    var i = this.roles.indexOf(this.currentRole);
    this.roles.splice(i, 1);
    var output = [];
    for (let element of this.roles) if (element != null && typeof (element) != "undefined") output.push(element);
    this.roles = output;
  }
  /**
   * the method saves the current role
   */
  saveCurrentRole(){
    let callback = (data: Role) => {
      this.currentRole.id = data.id;
      this.rolePointer = data.id;
      this.currentRole.isNew = false;
      let p = new PopUpData();
      p.message = this.currentRole.name + " wurde gespeichert";
      p.icon = "done";
      p.iconClass = "success";
      this.setPopUp(p);
    };
    if(this.currentRole.isNew){
      this.backEndService.post("api/role", this.currentRole).subscribe(callback);
    } else {
      this.backEndService.put("api/role", this.currentRole).subscribe(callback);
    }
  }
  /**
   * the method set's the pop up data
   */
  setPopUp(data: PopUpData) {
    this._popUp.openFromComponent(PopUpComponent, {
      duration: 2000,
      data: data
    });
  }
  /**
   * the method sets the current role
   */
  setRole(role: Role) {
    for(let i in this.valueMap) this.valueMap[i] = false;
    this.rolePointer = role.id;
    this.roleName = role.name;
    this.roleUserIds = this.currentUsers.map(x => x.id);
    this.backEndService.get("api/role-right/" + role.id).subscribe((result: RoleRight[]) => {
      for(let right of result) this.valueMap[right.ruleid.toString()] = right.value;
    });
  }
  /**
   * the method sets the current role's name
   */
  setRoleName(){
    this.currentRole.name = this.roleName;
    this.saveCurrentRole();
  }
  /**
   * the method sets a current role's right
   */
  setRoleRight(rule: Rule, event){
    let callback = (roleRight: RoleRight) => {
      this.valueMap[roleRight.ruleid.toString()] = roleRight.value;
    };
    if(event.checked) this.backEndService.get("api/role-right/permit/" + this.rolePointer + "/" + rule.ruleid).subscribe(callback);
    else if(!event.checked) this.backEndService.get("api/role-right/refuse/" + this.rolePointer + "/" + rule.ruleid).subscribe(callback);
  }
  /**
   * the method sets the current role's users
   */
  setRoleUsers(event){
    console.log(event, this.roleUserIds);
  }
  /**
   * the method toggles the passed group's visibility
   */
  toggleGroup(group: RuleGroup) {
    if(group == null) {
      if(this.toggleMap["_"]) this.toggleMap["_"] = false;
      else if(!this.toggleMap["_"]) this.toggleMap["_"] = true;
    } else {
      if(this.toggleMap[group.rulegroupid.toString()]) this.toggleMap[group.rulegroupid.toString()] = false;
      else if(!this.toggleMap[group.rulegroupid.toString()]) this.toggleMap[group.rulegroupid.toString()] = true;
    }
  }
}